import { useEffect, useState } from "react"
import { generateHref } from "../components/utils/generate-href";
import useUrl from "./useUrl";

const useSocialShareLinks = (story) => {
  const [_,currentUrlSlug]=useUrl();
  let shareSlug=""
  const [baseUrl, setBaseUrl] = useState();
  useEffect(() => {
    if (typeof window === "undefined") {
       console.log("Oops, `window` is not defined")
     } else {
      if (window.location.href.indexOf("yhteissivusto") > -1) {
        setBaseUrl("https://yhteissivusto.fiare.qtstage.io");
      } else if (window.location.href.indexOf("imediat-web") > -1) {
        setBaseUrl("https://imediat-web.fiare.qtstage.io");
      } else {
        setBaseUrl("https://ilkkapohjalainen.fi");
      }
     }

  }, [])
  switch (currentUrlSlug) {
    case "vaasalehti":
      shareSlug="vaasalehti"
      break;
    case "epari":
      shareSlug="epari"
      break;
    default:
      shareSlug=shareSlug
  }
  const generatedHref= generateHref(story,shareSlug);
  const fullLink=`${baseUrl}${generatedHref}`;
  return fullLink;
};
export default useSocialShareLinks;
